// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"43ded2df","265":"ded4eb7f","287":"cddf2fce","453":"ac8f629d","753":"e39202bd"}[chunkId] + ".chunk.js";
};